import { Colors } from "./../theme";
import { ApiImage, ApiPosition, ApiInteraction } from "./";
import { OptionMap } from "../client/option-map";

export const dateRanges: OptionMap = {
  d1: {
    label: "1800s - 1850s",
    color: "melon",
  },
  d2: {
    label: "1850s - 1900s",
    color: "pinkLight",
  },
  d3: {
    label: "1900s - 1950s",
    color: "mintLight",
  },
  d4: {
    label: "1950s - 2000s",
    color: "melon",
  },
  d5: {
    label: "2000s - present day",
    color: "violetLight",
  },
};

export const themeCategories: OptionMap = {
  medicines: {
    label: "Medicines",
    color: "mintLight",
  },
  pharmacy: {
    label: "Pharmacy",
    color: "melon",
  },
  equipment: {
    label: "Equipment",
    color: "violetLight",
  },
  nhs: {
    label: "NHS",
    color: "pinkLight",
  },
};

export interface ApiArtifactBase {
  Id: number;
  Name: string;
  LongName: string;
  Summary: string;
  PreviewImg: ApiImage;
  DateCategory: keyof typeof dateRanges;
}

export interface ApiImageArtifact extends ApiArtifactBase {
  Type: "photoArtifact";
  FullImg: ApiImage;
}

export interface ApiBookArtifact extends ApiArtifactBase {
  Type: "bookArtifact";
  Height: number;
  Width: number;
  Pages: ApiImage[];
  HasCover: boolean;
}

export interface ApiInteractionArtifact extends ApiArtifactBase {
  Type: "interactiveArtifact";
  ImgStart: ApiImage;
  ImgEnd: ApiImage;
  // Interaction: ApiInteraction;
}

export interface ApiThreeSixtyInteractionConfig {
  Position: ApiPosition;
  InteractionId: number;
}

export interface ApiThreeSixtyImage {
  Id: number;
  Image: ApiImage;
  InteractionConfig?: ApiThreeSixtyInteractionConfig;
}

export interface ApiThreeSixtyInteraction {
  Id: number;
  Interaction: ApiInteraction;
  Image: ApiImage;
  ImageId: number; // The 360 image id that interaction originates from
}

export interface ApiThreeSixtyArtifact extends ApiArtifactBase {
  Type: "threeSixtyArtifact";
  ThreeSixtyImages: ApiThreeSixtyImage[];
  Reverse?: boolean;
  ThreeSixtyInteractions: ApiThreeSixtyInteraction[];
}

export type ApiArtifact =
  | ApiImageArtifact
  | ApiBookArtifact
  | ApiThreeSixtyArtifact
  | ApiInteractionArtifact;
